module.exports = __webpack_public_path__ + "img/yhyj3_03.0af0f660.png";